// extracted by mini-css-extract-plugin
module.exports = {"episodeLink":"episode-module--episode-link--2ges-","episode":"episode-module--episode--Vatah","title":"episode-module--title--2etOP","blurb":"episode-module--blurb--27Ddt"};